// extracted by mini-css-extract-plugin
export default {"searchBox":"search_searchBox__zFHtl"};